var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c("FormItem", {
        scopedSlots: _vm._u([
          {
            key: "question",
            fn: function () {
              return [_vm._v("Shopping Cart")]
            },
            proxy: true,
          },
          {
            key: "action",
            fn: function () {
              return [
                _vm.items.length
                  ? _c(
                      "v-row",
                      { staticClass: "gap-2", attrs: { "no-gutters": "" } },
                      [
                        _c(
                          "div",
                          [
                            _c(
                              "v-btn",
                              {
                                staticClass: "soli-round",
                                attrs: {
                                  "x-small": "",
                                  outlined: "",
                                  color: "error",
                                },
                                on: {
                                  click: function ($event) {
                                    _vm.clearCartAlert = true
                                  },
                                },
                              },
                              [_vm._v("Clear Cart")]
                            ),
                          ],
                          1
                        ),
                      ]
                    )
                  : _vm._e(),
              ]
            },
            proxy: true,
          },
          {
            key: "response",
            fn: function () {
              return [
                _c(
                  "v-list",
                  { staticClass: "pa-0" },
                  [
                    _vm._l(_vm.items, function (item, idx) {
                      return _c(
                        "v-list-item",
                        {
                          key: item.id,
                          staticClass: "v-sheet--outlined soli-round",
                          class: { "mb-3": idx < _vm.items.length - 1 },
                        },
                        [
                          item.event_register
                            ? _c(
                                "v-list-item-content",
                                { staticClass: "text-align-start" },
                                [
                                  _c(
                                    "v-list-item-title",
                                    { staticClass: "soli-grey" },
                                    [
                                      _vm._v(
                                        "\n                            " +
                                          _vm._s(item.product.name)
                                      ),
                                    ]
                                  ),
                                  _vm._v(" "),
                                  item.event_register.details.location
                                    ? _c("v-list-item-subtitle", [
                                        _vm._v(
                                          _vm._s(
                                            `${item.event_register.details.location}`
                                          )
                                        ),
                                      ])
                                    : _vm._e(),
                                  _vm._v(" "),
                                  item.event_register?.group_event
                                    ? _c("v-list-item-subtitle", [
                                        _vm._v(
                                          _vm._s(
                                            `${item.event_register.group_event.title}`
                                          )
                                        ),
                                      ])
                                    : _vm._e(),
                                  _vm._v(" "),
                                  item.event_register.details.date
                                    ? _c("v-list-item-subtitle", [
                                        _vm._v(
                                          _vm._s(
                                            `${item.event_register.details.date}`
                                          )
                                        ),
                                      ])
                                    : _vm._e(),
                                  _vm._v(" "),
                                  item.event_register.details.time
                                    ? _c("v-list-item-subtitle", [
                                        _vm._v(
                                          _vm._s(
                                            `${item.event_register.details.time}`
                                          )
                                        ),
                                      ])
                                    : _vm._e(),
                                  _vm._v(" "),
                                  false
                                    ? _c(
                                        "v-row",
                                        { attrs: { "no-gutters": "" } },
                                        [
                                          _vm._l(
                                            item.recipients.map(
                                              (e) => e.recipient
                                            ),
                                            function (item) {
                                              return _c(
                                                "div",
                                                {
                                                  key: item.id,
                                                  staticStyle: {
                                                    width: "24px",
                                                  },
                                                },
                                                [
                                                  _c(
                                                    "v-avatar",
                                                    {
                                                      staticClass:
                                                        "stacked-avatar shadow-md",
                                                      attrs: { size: "28" },
                                                    },
                                                    [
                                                      _c("v-img", {
                                                        attrs: {
                                                          src: item.profile_photo_url,
                                                        },
                                                      }),
                                                    ],
                                                    1
                                                  ),
                                                ],
                                                1
                                              )
                                            }
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "v-btn",
                                            {
                                              staticClass:
                                                "gradient-orange shadow-orange-xl white--text pa-0.5",
                                              attrs: {
                                                icon: "",
                                                outlined: "",
                                                small: "",
                                              },
                                              on: {
                                                click: function ($event) {
                                                  return _vm.updateItem(
                                                    item,
                                                    item.quantity
                                                  )
                                                },
                                              },
                                            },
                                            [
                                              _c(
                                                "v-icon",
                                                { attrs: { small: "" } },
                                                [_vm._v("edit")]
                                              ),
                                            ],
                                            1
                                          ),
                                        ],
                                        2
                                      )
                                    : _vm._e(),
                                ],
                                1
                              )
                            : _c(
                                "v-list-item-content",
                                { staticClass: "text-align-start" },
                                [
                                  _c(
                                    "v-list-item-title",
                                    { staticClass: "soli-grey" },
                                    [
                                      _vm._v(
                                        "\n                            " +
                                          _vm._s(item.product.name)
                                      ),
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c("v-list-item-subtitle", [
                                    _vm._v(_vm._s(item.product.description)),
                                  ]),
                                  _vm._v(" "),
                                  item.price.package_name
                                    ? _c(
                                        "v-list-item-subtitle",
                                        { staticClass: "caption" },
                                        [
                                          _vm._v(
                                            "\n                            " +
                                              _vm._s(item.price.package_name)
                                          ),
                                        ]
                                      )
                                    : _vm._e(),
                                ],
                                1
                              ),
                          _vm._v(" "),
                          _c(
                            "v-list-item-action",
                            { staticClass: "justify-start" },
                            [
                              _c(
                                "span",
                                { staticClass: "text-lg px-1 soli-grey mb-05" },
                                [
                                  _vm._v(
                                    "\n                            " +
                                      _vm._s(item.price.formatAmount) +
                                      "\n                        "
                                  ),
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "v-sheet",
                                {
                                  staticClass: "soli-round my-1",
                                  attrs: { outlined: "" },
                                },
                                [
                                  _c(
                                    "v-btn",
                                    {
                                      attrs: {
                                        small: "",
                                        icon: "",
                                        color: "dark",
                                      },
                                      on: {
                                        click: function ($event) {
                                          return _vm.updateItem(
                                            item,
                                            item.quantity - 1
                                          )
                                        },
                                      },
                                    },
                                    [
                                      _c("v-icon", { attrs: { small: "" } }, [
                                        _vm._v("remove"),
                                      ]),
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "span",
                                    { staticClass: "px-2 soli-grey text-sm" },
                                    [_vm._v(_vm._s(item.quantity))]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "v-btn",
                                    {
                                      attrs: {
                                        small: "",
                                        icon: "",
                                        color: "dark",
                                      },
                                      on: {
                                        click: function ($event) {
                                          return _vm.updateItem(
                                            item,
                                            item.quantity + 1
                                          )
                                        },
                                      },
                                    },
                                    [
                                      _c("v-icon", { attrs: { small: "" } }, [
                                        _vm._v("add"),
                                      ]),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                [
                                  _c(
                                    "v-tooltip",
                                    {
                                      attrs: { bottom: "" },
                                      scopedSlots: _vm._u(
                                        [
                                          {
                                            key: "activator",
                                            fn: function ({ on, attrs }) {
                                              return [
                                                item.product.contract_id
                                                  ? _c(
                                                      "v-btn",
                                                      _vm._g(
                                                        _vm._b(
                                                          {
                                                            attrs: {
                                                              small: "",
                                                              icon: "",
                                                            },
                                                            on: {
                                                              click: function (
                                                                $event
                                                              ) {
                                                                item.contract_url
                                                                  ? (_vm.viewContract =
                                                                      item.contract_url)
                                                                  : _vm.$emit(
                                                                      "viewContract"
                                                                    )
                                                              },
                                                            },
                                                          },
                                                          "v-btn",
                                                          attrs,
                                                          false
                                                        ),
                                                        on
                                                      ),
                                                      [
                                                        _c(
                                                          "v-icon",
                                                          {
                                                            class: [
                                                              item.contract_url
                                                                ? "primary--text"
                                                                : "error--text",
                                                            ],
                                                            attrs: {
                                                              small: "",
                                                            },
                                                          },
                                                          [
                                                            _vm._v(
                                                              "description"
                                                            ),
                                                          ]
                                                        ),
                                                      ],
                                                      1
                                                    )
                                                  : _vm._e(),
                                              ]
                                            },
                                          },
                                        ],
                                        null,
                                        true
                                      ),
                                    },
                                    [_vm._v("View Agreement")]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "v-tooltip",
                                    {
                                      attrs: { bottom: "" },
                                      scopedSlots: _vm._u(
                                        [
                                          {
                                            key: "activator",
                                            fn: function ({ on, attrs }) {
                                              return [
                                                _c(
                                                  "v-btn",
                                                  _vm._g(
                                                    _vm._b(
                                                      {
                                                        attrs: {
                                                          small: "",
                                                          icon: "",
                                                          color: "dark",
                                                        },
                                                        on: {
                                                          click: function (
                                                            $event
                                                          ) {
                                                            ;[
                                                              _vm.$emit(
                                                                "delete",
                                                                item
                                                              ),
                                                            ]
                                                          },
                                                        },
                                                      },
                                                      "v-btn",
                                                      attrs,
                                                      false
                                                    ),
                                                    on
                                                  ),
                                                  [
                                                    _c(
                                                      "v-icon",
                                                      { attrs: { small: "" } },
                                                      [_vm._v("delete")]
                                                    ),
                                                  ],
                                                  1
                                                ),
                                              ]
                                            },
                                          },
                                        ],
                                        null,
                                        true
                                      ),
                                    },
                                    [_vm._v("Delete Item")]
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      )
                    }),
                    _vm._v(" "),
                    !_vm.items
                      ? _c("v-list-item", [_vm._v("Such Empty")])
                      : _vm._e(),
                  ],
                  2
                ),
              ]
            },
            proxy: true,
          },
        ]),
      }),
      _vm._v(" "),
      _vm.viewContract
        ? _c("SoliResponsiveDialog", {
            on: {
              reset: function ($event) {
                _vm.closeModal(() => (_vm.viewContract = false))
              },
            },
            scopedSlots: _vm._u(
              [
                {
                  key: "body",
                  fn: function () {
                    return [
                      _c("v-img", {
                        attrs: {
                          contain: "",
                          "max-height": "975",
                          src: _vm.viewContract,
                        },
                      }),
                    ]
                  },
                  proxy: true,
                },
              ],
              null,
              false,
              3644189724
            ),
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.clearCartAlert
        ? _c("SoliChoice", {
            attrs: {
              title: "Are you sure",
              subtitle:
                "This will remove all items and event reservations in your shopping cart",
              button1: "Clear Cart",
              button2: "Nevermind",
            },
            on: {
              option1: function ($event) {
                return _vm.$emit("clear")
              },
              reset: function ($event) {
                _vm.closeModal(() => (_vm.clearCartAlert = false))
              },
            },
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }